import { CALL_API, Schemas } from '../../common/middleware/api';
import globalize from '../../common/services/globalize';
import moment from 'moment';

export const PAYMENT_HISTORIES_REQUEST = 'PAYMENT_HISTORIES_REQUEST';
export const PAYMENT_HISTORIES_SUCCESS = 'PAYMENT_HISTORIES_SUCCESS';
export const PAYMENT_HISTORIES_FAILURE = 'PAYMENT_HISTORIES_FAILURE';

export const PAYMENT_HISTORIES_UNPAGED_REQUEST = 'PAYMENT_HISTORIES_UNPAGED_REQUEST';
export const PAYMENT_HISTORIES_UNPAGED_SUCCESS = 'PAYMENT_HISTORIES_UNPAGED_SUCCESS';
export const PAYMENT_HISTORIES_UNPAGED_FAILURE = 'PAYMENT_HISTORIES_UNPAGED_FAILURE';

export const PAYMENT_HISTORY_FETCH_REQUEST = 'PAYMENT_HISTORY_GET_REQUEST';
export const PAYMENT_HISTORY_FETCH_SUCCESS = 'PAYMENT_HISTORY_GET_SUCCESS';
export const PAYMENT_HISTORY_FETCH_FAILURE = 'PAYMENT_HISTORY_GET_FAILURE';

export const PAYMENT_HISTORY_UPDATE_REQUEST = 'PAYMENT_HISTORY_UPDATE_REQUEST';
export const PAYMENT_HISTORY_UPDATE_SUCCESS = 'PAYMENT_HISTORY_UPDATE_SUCCESS';
export const PAYMENT_HISTORY_UPDATE_FAILURE = 'PAYMENT_HISTORY_UPDATE_FAILURE';

export const PAYMENT_HISTORY_ADD_PROMO_CODE_REQUEST = 'PAYMENT_HISTORY_ADD_PROMO_CODE_REQUEST';
export const PAYMENT_HISTORY_ADD_PROMO_CODE_SUCCESS = 'PAYMENT_HISTORY_ADD_PROMO_CODE_SUCCESS';
export const PAYMENT_HISTORY_ADD_PROMO_CODE_FAILURE = 'PAYMENT_HISTORY_ADD_PROMO_CODE_FAILURE';

export const PAYMENT_HISTORY_MARK_AS_PAID_REQUEST = 'PAYMENT_HISTORY_MARK_AS_PAID_REQUEST';
export const PAYMENT_HISTORY_MARK_AS_PAID_SUCCESS = 'PAYMENT_HISTORY_MARK_AS_PAID_SUCCESS';
export const PAYMENT_HISTORY_MARK_AS_PAID_FAILURE = 'PAYMENT_HISTORY_MARK_AS_PAID_FAILURE';

export const PAYMENT_HISTORY_ADD_INSTALMENT_REQUEST = 'PAYMENT_HISTORY_ADD_INSTALMENT_REQUEST';
export const PAYMENT_HISTORY_ADD_INSTALMENT_SUCCESS = 'PAYMENT_HISTORY_ADD_INSTALMENT_SUCCESS';
export const PAYMENT_HISTORY_ADD_INSTALMENT_FAILURE = 'PAYMENT_HISTORY_ADD_INSTALMENT_FAILURE';
export const PAYMENT_HISTORY_MARK_AS_CANCELLED_REQUEST = 'PAYMENT_HISTORY_MARK_AS_CANCELLED_REQUEST';
export const PAYMENT_HISTORY_MARK_AS_CANCELLED_SUCCESS = 'PAYMENT_HISTORY_MARK_AS_CANCELLED_SUCCESS';
export const PAYMENT_HISTORY_MARK_AS_CANCELLED_FAILURE = 'PAYMENT_HISTORY_MARK_AS_CANCELLED_FAILURE';

export const PAYMENT_HISTORY_SEND_INVOICE_REQUEST = 'PAYMENT_HISTORY_SEND_INVOICE_REQUEST';
export const PAYMENT_HISTORY_SEND_INVOICE_SUCCESS = 'PAYMENT_HISTORY_SEND_INVOICE_SUCCESS';
export const PAYMENT_HISTORY_SEND_INVOICE_FAILURE = 'PAYMENT_HISTORY_SEND_INVOICE_FAILURE';

export const CANCEL_LESSON_REQUEST = 'CANCEL_LESSON_REQUEST';
export const CANCEL_LESSON_SUCCESS = 'CANCEL_LESSON_SUCCESS';
export const CANCEL_LESSON_FAILURE = 'CANCEL_LESSON_FAILURE';

export const RESTORE_CANCELLED_LESSON_REQUEST = 'RESTORE_CANCELLED_LESSON_REQUEST';
export const RESTORE_CANCELLED_LESSON_SUCCESS = 'RESTORE_CANCELLED_LESSON_SUCCESS';
export const RESTORE_CANCELLED_LESSON_FAILURE = 'RESTORE_CANCELLED_LESSON_FAILURE';

export const CANCEL_AND_REFUND_LESSON_REQUEST = 'CANCEL_AND_REFUND_LESSON_REQUEST';
export const CANCEL_AND_REFUND_LESSON_SUCCESS = 'CANCEL_AND_REFUND_LESSON_SUCCESS';
export const CANCEL_AND_REFUND_LESSON_FAILURE = 'CANCEL_AND_REFUND_LESSON_FAILURE';

export const PAYMENT_EXPORT_REQUEST = 'PAYMENT_EXPORT_REQUEST';
export const PAYMENT_EXPORT_SUCCESS = 'PAYMENT_EXPORT_SUCCESS';
export const PAYMENT_EXPORT_FAILURE = 'PAYMENT_EXPORT_FAILURE';

export const PAYMENTS_BY_CHILD_REQUEST = 'PAYMENTS_BY_CHILD_REQUEST';
export const PAYMENTS_BY_CHILD_SUCCESS = 'PAYMENTS_BY_CHILD_SUCCESS';
export const PAYMENTS_BY_CHILD_FAILURE = 'PAYMENTS_BY_CHILD_FAILURE';

export const PAYMENT_HISTORY_REFUND_UNBOOKED_ANNUAL_REQUEST = 'PAYMENT_HISTORY_REFUND_UNBOOKED_ANNUAL_REQUEST';
export const PAYMENT_HISTORY_REFUND_UNBOOKED_ANNUAL_SUCCESS = 'PAYMENT_HISTORY_REFUND_UNBOOKED_ANNUAL_SUCCESS';
export const PAYMENT_HISTORY_REFUND_UNBOOKED_ANNUAL_FAILURE = 'PAYMENT_HISTORY_REFUND_UNBOOKED_ANNUAL_FAILURE';

export const PAYMENT_HISTORY_RETRY_INSTALMENT_REQUEST = 'PAYMENT_HISTORY_RETRY_INSTALMENT_REQUEST';
export const PAYMENT_HISTORY_RETRY_INSTALMENT_SUCCESS = 'PAYMENT_HISTORY_RETRY_INSTALMENT_SUCCESS';
export const PAYMENT_HISTORY_RETRY_INSTALMENT_FAILURE = 'PAYMENT_HISTORY_RETRY_INSTALMENT_FAILURE';

export const loadPaymentHistories = (options) => ({
	[CALL_API]: {
		types: [PAYMENT_HISTORIES_REQUEST, PAYMENT_HISTORIES_SUCCESS, PAYMENT_HISTORIES_FAILURE],
		endpoint: 'api/lessonPayments',
		request: options,
		schema: Schemas.PAYMENT_HISTORY_ARRAY
	},
	parentId: options && options.parentId
});

export const loadPaymentHistoriesUnpaged = (options) => ({
	[CALL_API]: {
		types: [PAYMENT_HISTORIES_UNPAGED_REQUEST, PAYMENT_HISTORIES_UNPAGED_SUCCESS, PAYMENT_HISTORIES_UNPAGED_FAILURE],
		endpoint: 'api/lessonPayments/unpaged',
		request: options,
		schema: Schemas.PAYMENT_HISTORY_ARRAY
	}
});

export const SUBSCRIPTION_CANCELLATION_PREVIEW_REQUEST = 'SUBSCRIPTION_CANCELLATION_PREVIEW_REQUEST';
export const SUBSCRIPTION_CANCELLATION_PREVIEW_SUCCESS = 'SUBSCRIPTION_CANCELLATION_PREVIEW_SUCCESS';
export const SUBSCRIPTION_CANCELLATION_PREVIEW_FAILURE = 'SUBSCRIPTION_CANCELLATION_PREVIEW_FAILURE';

export const SUBSCRIPTION_CANCELLATION_REQUEST_REQUEST = 'SUBSCRIPTION_CANCELLATION_REQUEST_REQUEST';
export const SUBSCRIPTION_CANCELLATION_REQUEST_SUCCESS = 'SUBSCRIPTION_CANCELLATION_REQUEST_SUCCESS';
export const SUBSCRIPTION_CANCELLATION_REQUEST_FAILURE = 'SUBSCRIPTION_CANCELLATION_REQUEST_FAILURE';

export const SUBSCRIPTION_CANCELLATION_WITHDRAW_REQUEST = 'SUBSCRIPTION_CANCELLATION_WITHDRAW_REQUEST';
export const SUBSCRIPTION_CANCELLATION_WITHDRAW_SUCCESS = 'SUBSCRIPTION_CANCELLATION_WITHDRAW_SUCCESS';
export const SUBSCRIPTION_CANCELLATION_WITHDRAW_FAILURE = 'SUBSCRIPTION_CANCELLATION_WITHDRAW_FAILURE';

export const SUBSCRIPTION_ACCEPTANCE_FETCH_REQUEST = 'SUBSCRIPTION_ACCEPTANCE_FETCH_REQUEST';
export const SUBSCRIPTION_ACCEPTANCE_FETCH_SUCCESS = 'SUBSCRIPTION_ACCEPTANCE_FETCH_SUCCESS';
export const SUBSCRIPTION_ACCEPTANCE_FETCH_FAILURE = 'SUBSCRIPTION_ACCEPTANCE_FETCH_FAILURE';

// what the parent was shown and accepted at checkout
export const fetchSubscriptionAcceptance = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [SUBSCRIPTION_ACCEPTANCE_FETCH_REQUEST, SUBSCRIPTION_ACCEPTANCE_FETCH_SUCCESS, SUBSCRIPTION_ACCEPTANCE_FETCH_FAILURE],
		endpoint: `api/lessonPayments/${id}/subscription/acceptance`,
		onSuccessEvent
	}
});

// what cancelling the subscription with a request made at requestedAt would mean
export const fetchSubscriptionCancellationPreview = (id, requestedAt, onSuccessEvent) => ({
	[CALL_API]: {
		types: [SUBSCRIPTION_CANCELLATION_PREVIEW_REQUEST, SUBSCRIPTION_CANCELLATION_PREVIEW_SUCCESS, SUBSCRIPTION_CANCELLATION_PREVIEW_FAILURE],
		endpoint: `api/lessonPayments/${id}/subscription/cancellationPreview`,
		request: requestedAt ? { requestedAt } : undefined,
		onSuccessEvent
	}
});

// a cancellation the parent asked for by phone, email or in person
export const requestSubscriptionCancellation = (id, request, onSuccessEvent) => ({
	[CALL_API]: {
		types: [SUBSCRIPTION_CANCELLATION_REQUEST_REQUEST, SUBSCRIPTION_CANCELLATION_REQUEST_SUCCESS, SUBSCRIPTION_CANCELLATION_REQUEST_FAILURE],
		endpoint: `api/lessonPayments/${id}/subscription/cancellationRequest`,
		method: 'POST',
		request,
		schema: Schemas.PAYMENT_HISTORY,
		form: 'subscriptionCancellation',
		onSuccessEvent
	}
});

export const withdrawSubscriptionCancellation = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [SUBSCRIPTION_CANCELLATION_WITHDRAW_REQUEST, SUBSCRIPTION_CANCELLATION_WITHDRAW_SUCCESS, SUBSCRIPTION_CANCELLATION_WITHDRAW_FAILURE],
		endpoint: `api/lessonPayments/${id}/subscription/cancellationRequest`,
		method: 'DELETE',
		schema: Schemas.PAYMENT_HISTORY,
		form: 'paymentHistory',
		onSuccessEvent
	}
});

export const fetchPaymentHistory = (id) => ({
	[CALL_API]: {
		types: [PAYMENT_HISTORY_FETCH_REQUEST, PAYMENT_HISTORY_FETCH_SUCCESS, PAYMENT_HISTORY_FETCH_FAILURE],
		endpoint: `api/lessonPayments/${id}`,
		schema: Schemas.PAYMENT_HISTORY
	}
});

export const updatePaymentHistory = (id, paymentHistory) => ({
	[CALL_API]: {
		types: [PAYMENT_HISTORY_UPDATE_REQUEST, PAYMENT_HISTORY_UPDATE_SUCCESS, PAYMENT_HISTORY_UPDATE_FAILURE],
		endpoint: `api/lessonPayments/${id}`,
		method: 'PUT',
		request: paymentHistory,
		schema: Schemas.PAYMENT_HISTORY,
		form: 'paymentHistory'
	}
});

export const applyPromoCode = (id, promoCode, onSuccessEvent) => ({
	[CALL_API]: {
		types: [PAYMENT_HISTORY_ADD_PROMO_CODE_REQUEST, PAYMENT_HISTORY_ADD_PROMO_CODE_SUCCESS, PAYMENT_HISTORY_ADD_PROMO_CODE_FAILURE],
		endpoint: `api/paymentHistory/${id}/promoCode`,
		method: 'POST',
		request: { promoCode },
		schema: Schemas.PAYMENT_HISTORY,
		form: 'applyPromoCode',
		onSuccessEvent
	}
});

export const markAsPaid = (id, options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [PAYMENT_HISTORY_MARK_AS_PAID_REQUEST, PAYMENT_HISTORY_MARK_AS_PAID_SUCCESS, PAYMENT_HISTORY_MARK_AS_PAID_FAILURE],
		endpoint: `api/paymentHistory/${id}/markAsPaid`,
		method: 'PUT',
		request: options,
		schema: Schemas.PAYMENT_HISTORY,
		form: 'markAsPaid',
		onSuccessEvent
	}
});

export const addInstalment = (id, options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [PAYMENT_HISTORY_ADD_INSTALMENT_REQUEST, PAYMENT_HISTORY_ADD_INSTALMENT_SUCCESS, PAYMENT_HISTORY_ADD_INSTALMENT_FAILURE],
		endpoint: `api/lessonPayments/${id}/addInstalment`,
		method: 'PUT',
		request: options,
		schema: Schemas.PAYMENT_HISTORY,
		form: 'addInstalment',
		onSuccessEvent
	}
});

export const markAsCancelled = (id, options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [PAYMENT_HISTORY_MARK_AS_CANCELLED_REQUEST, PAYMENT_HISTORY_MARK_AS_CANCELLED_SUCCESS, PAYMENT_HISTORY_MARK_AS_CANCELLED_FAILURE],
		endpoint: `api/paymentHistory/${id}/markAsCancelled`,
		method: 'PUT',
		request: options,
		schema: Schemas.PAYMENT_HISTORY,
		form: 'markAsCancelled',
		onSuccessEvent
	}
});

export const cancelLesson = (lessonId, onSuccessEvent) => ({
	[CALL_API]: {
		types: [CANCEL_LESSON_REQUEST, CANCEL_LESSON_SUCCESS, CANCEL_LESSON_FAILURE],
		endpoint: `api/childLessons/cancel/${lessonId}`,
		method: 'PUT',
		schema: Schemas.PAYMENT_HISTORY,
		form: 'enrolment',
		onSuccessEvent
	}
});

export const restoreCancelledLesson = (lessonId, onSuccessEvent) => ({
	[CALL_API]: {
		types: [RESTORE_CANCELLED_LESSON_REQUEST, RESTORE_CANCELLED_LESSON_SUCCESS, RESTORE_CANCELLED_LESSON_FAILURE],
		endpoint: `api/childLessons/restoreCancelled/${lessonId}`,
		method: 'PUT',
		schema: Schemas.PAYMENT_HISTORY,
		form: 'enrolment',
		onSuccessEvent
	}
});

export const cancelAndRefundLesson = (lessonId, options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [CANCEL_AND_REFUND_LESSON_REQUEST, CANCEL_AND_REFUND_LESSON_SUCCESS, CANCEL_AND_REFUND_LESSON_FAILURE],
		endpoint: `api/childLessons/cancelAndRefund/${lessonId}`,
		method: 'PUT',
		request: options,
		schema: Schemas.PAYMENT_HISTORY,
		form: 'refundForm',
		onSuccessEvent
	}

});
export const exportPaymentHistories = (exportFormat, options, onSuccessEvent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [PAYMENT_EXPORT_REQUEST, PAYMENT_EXPORT_SUCCESS, PAYMENT_EXPORT_FAILURE],
			endpoint: `api/lessonPayments/export/${exportFormat === 'Xero' ? 'xero' : ''}`,
			request: {
				...options,
				timeZone: globalize.getCurrentTimeZone(getState().configuration.franchisor)
			},
			onSuccessEvent
		},
		format: exportFormat,
		filename: () => `PaymentReport-${moment().format('YYYY-MM-DD')}.${exportFormat === 'Xero' ? 'csv' : 'xlsx'}`
	});
}

export const loadPaymentsForChild = (childId) => (dispatch, getState) => {
	const paymentsByChild = getState().filters.paymentsByChild;
	if (paymentsByChild[childId]) {
		return null;
	}

	dispatch({
		[CALL_API]: {
			types: [PAYMENTS_BY_CHILD_REQUEST, PAYMENTS_BY_CHILD_SUCCESS, PAYMENTS_BY_CHILD_FAILURE],
			endpoint: 'api/lessonPayments',
			request: { childId, pageSize: 999 },
			schema: Schemas.PAYMENT_HISTORY_ARRAY
		},
		childId
	});
};

export const sendInvoice = (id) => ({
	[CALL_API]: {
		types: [PAYMENT_HISTORY_SEND_INVOICE_REQUEST, PAYMENT_HISTORY_SEND_INVOICE_SUCCESS, PAYMENT_HISTORY_SEND_INVOICE_FAILURE],
		endpoint: `api/lessonPayments/${id}/sendInvoice`,
		method: 'PUT',
		schema: Schemas.PAYMENT_HISTORY
	}
});

export const refundUnbookedAnnual = (id, options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [PAYMENT_HISTORY_REFUND_UNBOOKED_ANNUAL_REQUEST, PAYMENT_HISTORY_REFUND_UNBOOKED_ANNUAL_SUCCESS, PAYMENT_HISTORY_REFUND_UNBOOKED_ANNUAL_FAILURE],
		endpoint: `api/lessonPayments/${id}/refundUnbookedAnnual`,
		method: 'PUT',
		request: options,
		schema: Schemas.PAYMENT_HISTORY,
		form: 'refundUnbookedAnnual',
		onSuccessEvent
	}
});

export const retryInstalment = (paymentId, instalmentPaymentId, onSuccessEvent) => ({
	[CALL_API]: {
		types: [PAYMENT_HISTORY_RETRY_INSTALMENT_REQUEST, PAYMENT_HISTORY_RETRY_INSTALMENT_SUCCESS, PAYMENT_HISTORY_RETRY_INSTALMENT_FAILURE],
		endpoint: `api/paymentHistory/${paymentId}/retryInstalment`,
		method: 'POST',
		request: { instalmentPaymentId },
		schema: Schemas.PAYMENT_HISTORY,
		onSuccessEvent
	}
});
